import { ReactNode } from 'react';

import { Body, cn } from '@growtherapy/sprout-ui';

import { useTheme } from '../../hooks/useTheme';
import { Theme } from '../../state/theme';

export function HelpModalItem({ heading, description }: { heading: string; description: ReactNode }) {
  const { theme } = useTheme();

  const isDarkTheme = theme === Theme.DARK;

  return (
    <li
      className={cn(
        'border-b border-neutral-500 pb-6 last-of-type:border-none last-of-type:pb-0 relative before:absolute before:content-[counter(list-item)] before:bg-neutral-400 before:text-neutral-800 before:rounded-full before:items-center before:justify-center before:text-xs before:px-2 before:py-1 before:w-fit before:inline-block',
        'rebrand:before:p-0 rebrand:before:bg-transparent rebrand:before:top-125 rebrand:before:text-text-default rebrand:border-border-default',
        {
          'rebrand:before:text-text-inverse': isDarkTheme,
        },
      )}
    >
      <Body.Default
        as='h3'
        className={cn('text-medium font-normal text-neutral-800 ml-8 pb-2 rebrand:text-text-default', {
          'rebrand:text-text-inverse': isDarkTheme,
        })}
      >
        {heading}
      </Body.Default>
      <Body.Default
        as='div'
        className={cn('text-medium font-normal text-neutral-800 ml-8 rebrand:text-text-default', {
          'rebrand:text-text-inverse': isDarkTheme,
        })}
      >
        {description}
      </Body.Default>
    </li>
  );
}
